<template>
  <v-app-bar absolute=""  id="app-bar" color="transparent" height="75">
    <v-spacer></v-spacer>
  

    <!-- <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$route.name"
    /> -->
    <div >
    <v-btn color="primary"  fab  class="mr-3" elevation="1" small @click="setDrawer(!drawer)">

       <span style="font-size:12px;" v-text="$t('menu')"></span>
    
    </v-btn>
    <v-btn
      fab
      color="primary" 
      elevation="1"
      small
      @click="changeLanguage"
      v-text="$t('siteLanguage')"
    ></v-btn>
    
    </div>
      

    
<v-spacer></v-spacer>
   

  

    
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from "vuetify/lib";

// Utilities
import { mapState, mapMutations } from "vuex";

export default {
  name: "DashboardCoreAppBar",

  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs
                  }
                },
                this.$slots.default
              );
            }
          }
        });
      }
    }
  },

  props: {
    target: {
      type: String,
      default: " "
    },
    value: {
      type: Boolean,
      default: false
    }
  },


  computed: {
    ...mapState(["drawer"])
  },

  methods: {
    changeLanguage() {
      debugger;
      if (this.$i18n.locale == "en") {
        this.$i18n.locale = "fa";
        this.$vuetify.rtl = true;
      } else {
        this.$i18n.locale = "en";
        this.$vuetify.rtl = false;
      }
    },
    ...mapMutations({
      setDrawer: "SET_DRAWER"
    })
  }
};
</script>
